// 2026-05-21: render an item's specifications as a single " | " line, ordered so a
// "Brand" row comes first (Array.sort is stable, so the rest keep their entered order).
// A bare-numeric value (e.g. a "Piece"/"Pack" count of 200) is ambiguous on its own,
// so we append its attribute label → "200 Piece". Weight/Volume already embed a unit
// ("1 kilogram", "300 ml") and descriptive values (Brand/Flavour) are self-explanatory.
export function specsToLine(specs: Array<{ label: string; value: string }> | null | undefined): string {
  return [...(specs ?? [])]
    .sort((a, b) => {
      const ab = a.label.trim().toLowerCase() === "brand" ? 0 : 1;
      const bb = b.label.trim().toLowerCase() === "brand" ? 0 : 1;
      return ab - bb;
    })
    .map((s) => {
      const v = (s.value ?? "").trim();
      if (!v) return "";
      const label = s.label.trim();
      return /^\d+(\.\d+)?$/.test(v) && label ? `${v} ${label}` : v;
    })
    .filter(Boolean)
    .join(" | ");
}
